import { createContext } from "react";

import { SignalRContextState } from "./types/interfaces";

const SignalRContext = createContext({} as SignalRContextState);

export default SignalRContext;
